module.exports = __webpack_public_path__ + "img/22_52.2c1216a2.png";